<template>
  <div style="display: flex;flex-wrap: nowrap" class="count-page">
    <div style="width: 50%;padding-right: 10px">
      <h2 style="width: 100%;text-align: center">出库单基础信息</h2>
      <el-descriptions class="margin-top" :column="3" border>
        <el-descriptions-item label="出库单号">{{outBoundOrder.order_id}}</el-descriptions-item>
        <el-descriptions-item label="出库仓库">{{outBoundOrder.warehouse}}</el-descriptions-item>
        <el-descriptions-item label="出库单类型">{{outBoundOrder.order_type}}</el-descriptions-item>
        <el-descriptions-item label="责任人">{{outBoundOrder.charge_user_id}}</el-descriptions-item>
        <el-descriptions-item label="出库单领取时间">{{outBoundOrder.take_time}}</el-descriptions-item>
      </el-descriptions>
      <div class="card" style="margin: 10px 0">
        <h2 style="width: 100%;text-align: center">装箱物料录入</h2>
        <div class="input-line">
          <text class="input-title">纸箱编号：</text>
          <el-input v-model="packingInfo.packageNo" placeholder="请扫描纸箱编号" style="width: 250px"></el-input>
        </div>
        <div class="input-line">
          <text class="input-title" style="line-height: 32px">物料编码：</text>
          <el-select @change="setItemId()" v-model="packingInfo.itemId" filterable placeholder="请选择物料编码" clearable style="width: 250px;margin-right: 20px">
            <el-option v-for="item in outBoundOrderItems" :key="item.id" :label="item.item_code" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="input-line" v-if="orderItem.sn_flag">
          <text class="input-title">SN码：</text>
          <el-input v-model="packingInfo.itemSn" placeholder="请扫描序列号" style="width: 250px"></el-input>
          <el-button type="success" style="margin-left: 20px" @click="submitItemSn" :loading="loading.itemSnBtn">提交物料序列号</el-button>
        </div>
        <div class="input-line" v-if="!orderItem.sn_flag">
          <text class="input-title" style="line-height: 32px">装箱数量：</text>
          <el-input-number v-model="packingInfo.itemPackCnt" style="width: 250px"></el-input-number>
          <el-button type="success" style="margin-left: 20px" @click="submitItemQty" :loading="loading.itemQtyBtn">提交物料数量</el-button>
        </div>
      </div>
      <div class="card">
        <h2 style="width: 100%;text-align: center">已装箱清单</h2>
        <div style="overflow-y: auto;" :style="'height:' + (cardHeight - 441) + 'px;'">
          <div v-for="item in packingList" :key="item.package_no" class="pack">
            <h4 style="width: 100%;text-align: center">纸箱编号：{{item.package_no}}</h4>
            <h4 style="width: 100%;">物料明细</h4>
            <div v-for="packing in item.packingList" :key="packing.id" class="material">
              <div>
                <div><text class="input-title">物料编码：</text>{{packing.item_code}}</div>
                <div><text class="input-title">物料名称：</text>{{packing.item_name}}</div>
              </div>
              <div v-if="!packing.sn_flag">
                <text class="input-title">装箱数量：</text>
                <el-input-number v-model="packing.actual_pack_qty"></el-input-number>
                <el-button style="margin-left: 20px" type="warning" :loading="loading.updatePackCntBtn" @click="updatePackCnt(packing.id,packing.actual_pack_qty)">修改物料数量</el-button>
              </div>
              <div v-if="packing.sn_flag"><text class="input-title">装箱数量：</text>{{packing.actual_pack_qty}}</div>
              <div v-if="packing.sn_flag">
                <text class="input-title">SN明细：</text>
                <div style="display: flex;flex-wrap: wrap">
                  <div v-for="sn in packing.sn_list" :key="sn" class="sn-text">
                    <text>{{sn}}</text>
                    <el-button @click="deleteSn(packing.id,sn)" :loading="loading.deleteSnBtn" size="small" style="margin-left: 10px;margin-top: 2px" icon="el-icon-delete" type="warning"></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 100%;text-align: center;margin: 10px 0">
        <el-button type="success" :loading="loading.submitFinishBtn" @click="submitPickFinish">出库单拣货完成</el-button>
      </div>
    </div>
    <div ref="rightCard" style="width: 50%;padding-left: 10px">
      <div class="card" style="margin-bottom: 10px">
        <h2 style="width: 100%;text-align: center">出库物料指示</h2>
        <el-table :data="outBoundOrderItems" style="width: 100%" :height="cardHeight / 2 - 70" :row-class-name="tableRowClassName">
          <el-table-column prop="item_code" label="物料编码"></el-table-column>
          <el-table-column prop="item_name" label="物料名称"></el-table-column>
          <el-table-column prop="positions" label="物料库位"></el-table-column>
          <el-table-column prop="item_qty" align="center" label="计划装箱" width="80"></el-table-column>
          <el-table-column prop="actual_item_qty" align="center" label="已装箱" width="80"></el-table-column>
          <el-table-column prop="not_pack_cnt" align="center" label="未装箱" width="80"></el-table-column>
          <el-table-column prop="is_sn_flag" align="center" label="是否SN管控" width="100"></el-table-column>
        </el-table>
      </div>
      <div class="card">
        <h2 style="width: 100%;text-align: center">出库装箱指示</h2>
        <div style="overflow-y: auto" :style="'height:' + (cardHeight / 2 - 70) + 'px;'">
          <div v-for="item in packages" :key="item.package_no" class="pack">
            <h4 style="width: 100%;text-align: center">指示箱号：{{item.package_no}}</h4>
            <div v-for="piece in item.pieces" :key="piece.id" class="material">
              <div>
                <div><text class="title">物料编码：</text>{{piece.item_code}}</div>
                <div><text class="title">物料名称：</text>{{piece.item_name}}</div>
              </div>
              <div style="display: flex;flex-wrap: nowrap">
                <div style="width: 33%"><text class="title">装箱数量：</text>{{piece.item_qty}}</div>
                <div style="width: 33%"><text class="title">箱头尺寸：</text>{{piece.cartonId}}</div>
              </div>
              <div style="display: flex;flex-wrap: nowrap">
                <div style="width: 33%"><text class="title">打包方式：</text>{{piece.pack_method}}</div>
                <div style="width: 33%"><text class="title">纸箱编码：</text>{{piece.container_code}}</div>
                <div style="width: 33%"><text class="title">纸箱校验码：</text>{{piece.carton_check_code}}</div>
              </div>
              <div style="word-wrap: break-word">
                <text class="title">备注：</text>
                <text style="width: 100%">{{piece.remarks}}</text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DjiOutBoundOrderPick",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading:{
        updatePackCntBtn: false,
        deleteSnBtn:false,
        itemSnBtn:false,
        itemQtyBtn:false,
        submitFinishBtn: false
      },
      cardHeight:0,
      outBoundOrder: {},
      outBoundOrderItems:[],
      packages:[],
      packingList:[],
      packingInfo:{
        id: '',
        packageNo: '-',
        itemSn: '',
        itemId: '',
        itemPackCnt: 0
      },
      orderItem: {}
    }
  },
  mounted() {
    this.getCardHeight()
    window.addEventListener('resize', this.getCardHeight)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.getCardHeight)
  },
  async created() {
    await this.getOutBoundOrder()
    await this.getOutBoundOrderItems()
    await this.getOutBoundOrderPieces()
    await this.getOutBoundOrderPackingList()
  },
  methods: {
    async setItemId() {
      if (this.packingInfo.itemId !== undefined) {
        let data = await this.$http('outBoundService.getOutBoundOrderItem', {itemId: this.packingInfo.itemId});
        this.orderItem = data
      }else {
        this.orderItem = {}
      }
    },
    async updatePackCnt(packingId,actualPackQty){
      this.loading.updatePackCntBtn = true;
      this.$http('outBoundService.updatePackCnt', {id: this.packingInfo.id, packingId: packingId, actualPackQty: actualPackQty}, false).then(data => {
        this.loading.updatePackCntBtn = false;
        this.$message.success("装箱数量修改成功");
        this.getOutBoundOrderItems()
        this.getOutBoundOrderPackingList()
      }, errMsg => {
        this.loading.updatePackCntBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async deleteSn(packingId,sn) {
      this.loading.deleteSnBtn = true;
      this.$http('outBoundService.deleteItemSn', {id: this.packingInfo.id, itemSn: sn, packingId: packingId}, false).then(data => {
        this.loading.deleteSnBtn = false;
        this.$message.success("序列号删除成功");
        this.getOutBoundOrderItems()
        this.getOutBoundOrderPackingList()
      }, errMsg => {
        this.loading.deleteSnBtn = false;
        return this.$message.error(errMsg);
      })
    },
    tableRowClassName({row}) {
      if (row.not_pack_cnt !== 0) {
        return 'warning-row';
      } else if (row.not_pack_cnt === 0) {
        return 'success-row';
      }
      return '';
    },
    getCardHeight() {
      if (this.$refs.rightCard) {
        this.cardHeight = this.$refs.rightCard.offsetHeight
      }
    },
    async submitPickFinish(){
      this.loading.submitFinishBtn = true;
      this.$http('outBoundService.submitPickFinish', {id: this.outBoundOrder.order_id}, false).then(data => {
        this.loading.submitFinishBtn = false;
        this.$message.success("提交拣货成功");
      }, errMsg => {
        this.loading.submitFinishBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async submitItemQty(){
      this.loading.itemQtyBtn = true;
      this.$http('outBoundService.submitItemQty', this.packingInfo, false).then(data => {
        this.loading.itemQtyBtn = false;
        this.$message.success("提交物料数量成功");
        this.getOutBoundOrderItems()
        this.getOutBoundOrderPackingList()
      }, errMsg => {
        this.loading.itemQtyBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async submitItemSn() {
      this.loading.itemSnBtn = true;
      this.$http('outBoundService.submitItemSn', this.packingInfo, false).then(data => {
        this.loading.itemSnBtn = false;
        this.$message.success("提交物料序列号成功：" + this.packingInfo.itemSn);
        this.getOutBoundOrderItems()
        this.getOutBoundOrderPackingList()
      }, errMsg => {
        this.loading.itemSnBtn = false;
        return this.$message.error(errMsg);
      })
    },
    //获取出库单明细
    async getOutBoundOrder() {
      let data = await this.$http('outBoundService.getOutBoundOrder', {id: this.parentData.id,});
      this.outBoundOrder = data;
      this.packingInfo.id = this.outBoundOrder.order_id;
    },
    //获取出库物料明细
    async getOutBoundOrderItems() {
      let data = await this.$http('outBoundService.getOutBoundOrderItems', {id: this.parentData.id,});
      this.outBoundOrderItems = data;
    },
    //获取出库推荐装箱指示
    async getOutBoundOrderPieces() {
      let data = await this.$http('outBoundService.getOutBoundOrderPieces', {id: this.parentData.id,});
      this.packages = data;
    },
    //获取出库装箱数据
    async getOutBoundOrderPackingList() {
      let data = await this.$http('outBoundService.getOutBoundOrderPackingList', {id: this.parentData.id,});
      this.packingList = data;
    }
  }
}
</script>

<style scoped lang="less">
.count-page{
  margin: 10px;
}
.card{
  padding: 10px;
  border: 1.5px solid #dcdfe6;
}
.pack{
  margin-bottom: 5px;
  padding: 5px;
  border: 1px solid green;
}
.material{
  margin: 5px 0;
  padding: 5px;
  border: 1px solid #dcdfe6;
}
.title{
  font-weight: bold;
}
.el-table ::v-deep(.warning-row) {
  background: oldlace;
}
.el-table ::v-deep(.success-row) {
  background: #7FFFAA;
}
.input-title{
  width: 80px;
  font-weight: bold;
  line-height: 32px;
}
.input-line{
  display: flex;
  flex-wrap: nowrap;
  margin: 10px 0;
}
.sn-text{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 30%;
  border: 1px solid #dcdfe6;
  border-radius: 5px;
  height: 36px;
  line-height: 30px;
  padding: 3px 5px;
  margin: 5px;
}
</style>